export const ENERGY_PRODUCERS = {
  GENERATOR: 'Generator',
  INVERTER: 'Inverter',
  PV_MODULE: 'PvModule',
  STORAGE: 'Storage',
  POWER_CONVERTER: 'PowerConverter',
};

export const ENERGY_TYPES = {
  PHOTOVOLTAICS: 0,
  STORAGE: 1,
  BHKW: 2,
  WIND_POWER_PLANT: 3,
  HYDRO_POWER_PLANT: 4,
  FUEL: 5,
  OTHER: 6,
};

export const ENERGY_SOURCES = {
  SOLAR: 0,
  WIND: 1,
  WATER: 2,
  BIOMASS: 3,
  NATURAL_GAS: 4,
  OTHER: 5,
};

export const MIN_TOTAL_FEED_IN_POWER_FOR_CENTRAL_GRID_PROTECTION = 30;

export const STORAGE_CONNECTIONS = {
  AC: 'AC',
  DC: 'DC',
};
